<template>
  <div class="content" :style="isWeixinPc?'overflow: hidden':''">
    <div class="head-box" :style="{ paddingTop: statusBarHeight }">
      <img
        class="head-bg"
        src="https://sz.daolongsz.com/static/head_bg.png"
        alt=""
      />
      <!-- <div class="head">
        <i class="iconfont icon-xiangzuo" @click="onBack"></i>
        <span>四柱辨证</span>
      </div> -->
    </div>
    <img
      class="_w-max"
      src="https://sz.daolongsz.com/static/head_bg.png"
      alt=""
    />
    <div class="tips-box">
      <img
        class="_w-max"
        src="https://sz.daolongsz.com/static/test-tips.png"
        alt=""
      />
    </div>
    <div class="acea-row row-middle row-center _mar-top-10">
      <img
        class="write-tips"
        src="https://sz.daolongsz.com/static/test-write-tips.png"
        alt=""
      />
    </div>
    <div class="form-bg">
      <div class="form-box">
        <div class="sex-box _flex-row-bet-mid">
          <div>性别 (<span class="iconfont icon-duihao2"></span>)</div>
          <div class="_flex-row-mid">
            <div class="_flex-row-mid" @click="selectSex(1)">
              <img
                v-if="sex == 1"
                class="_w-15 _h-15 _mar-right-10"
                src="@assets/images/icon/test-xuanzhong.png"
                alt=""
              />
              <img
                v-else
                class="_w-15 _h-15 _mar-right-10"
                src="@assets/images/icon/test-weixuanzhong.png"
                alt=""
              />
              <div>先生</div>
            </div>
            <div class="_flex-row-mid _mar-left-25" @click="selectSex(2)">
              <img
                v-if="sex == 2"
                class="_w-15 _h-15 _mar-right-10"
                src="@assets/images/icon/test-xuanzhong.png"
                alt=""
              />
              <img
                v-else
                class="_w-15 _h-15 _mar-right-10"
                src="@assets/images/icon/test-weixuanzhong.png"
                alt=""
              />
              <div>女士</div>
            </div>
          </div>
        </div>
        <div class="birthday-box">
          <div class="_w-max _flex-row-bet-mid padding-x">
            <div>
              <div>
                选择出生日期 (<span class="iconfont icon-duihao2"></span>)
              </div>
            </div>
            <div class="_flex-row-mid">
              <div style="color: #f00; font-size: 14px">
                闰月出生的，请填写阳历出生日
              </div>
            </div>
          </div>
          <div class="_w-max _flex-row-bet-mid padding-x _mar-top-20">
            <div class="_flex-row-mid">
              <div class="_flex-row-mid" @click="selectLunisolar(1)">
                <img
                  v-if="lunisolar == 1"
                  class="_w-15 _h-15 _mar-right-10"
                  src="@assets/images/icon/test-xuanzhong.png"
                  alt=""
                />
                <img
                  v-else
                  class="_w-15 _h-15 _mar-right-10"
                  src="@assets/images/icon/test-weixuanzhong.png"
                  alt=""
                />
                <div>阴历</div>
              </div>
              <div
                class="_flex-row-mid _mar-left-25"
                @click="selectLunisolar(2)"
              >
                <img
                  v-if="lunisolar == 2"
                  class="_w-15 _h-15 _mar-right-10"
                  src="@assets/images/icon/test-xuanzhong.png"
                  alt=""
                />
                <img
                  v-else
                  class="_w-15 _h-15 _mar-right-10"
                  src="@assets/images/icon/test-weixuanzhong.png"
                  alt=""
                />
                <div>阳历</div>
              </div>
            </div>
          </div>
          <div class="_w-max _flex-row-bet-mid _mar-top-10 padding-x">
            <div class="_flex-row-mid">
              <div
                class="day-box year-box _flex-row-bet-mid"
                @click="yearPicker = true"
              >
                {{ year ? year : "---" }}
                <img
                  class="_w-15 _h-15 _mar-left-10"
                  src="@assets/images/icon/test-icon.png"
                  alt=""
                />
              </div>
              <div class="_mar-left-10">年</div>
            </div>
            <div class="_flex-row-mid">
              <div
                class="day-box _flex-row-bet-mid"
                @click="monthPicker = true"
              >
                {{ month ? month : "---" }}
                <img
                  class="_w-15 _h-15 _mar-left-10"
                  src="@assets/images/icon/test-icon.png"
                  alt=""
                />
              </div>
              <div class="_mar-left-10">月</div>
            </div>
            <div class="_flex-row-mid">
              <div class="day-box _flex-row-bet-mid" @click="dayPicker = true">
                {{ day ? day : "---" }}
                <img
                  class="_w-15 _h-15 _mar-left-10"
                  src="@assets/images/icon/test-icon.png"
                  alt=""
                />
              </div>
              <div class="_mar-left-10">日</div>
            </div>
          </div>
          <div
            class="_w-max _flex-row-mid _mar-top-20 _pad-bottom-20 padding-x"
          >
            <div
              class="day-box time-box _flex-row-bet-mid"
              @click="timePicker = true"
            >
              {{ time ? time : "---" }}
              <img
                class="_w-15 _h-15 _mar-left-10"
                src="@assets/images/icon/test-icon.png"
                alt=""
              />
            </div>
            <div class="_mar-left-10">时</div>
          </div>
		  <div
		    class="_w-max _flex-row-mid _pad-bottom-20 padding-x"  style="border-bottom: 1px solid rgba(105, 80, 60, 0.1)">
		    <div></div>
		    <div class="_flex-row-mid">
		      <div class="_flex-row-mid" @click="selectHour()">
		        <img
		          v-if="has_hour == true"
		          class="_w-15 _h-15 _mar-right-10"
		          src="@assets/images/icon/test-xuanzhong.png"
		          alt=""
		        />
		        <img
		          v-else
		          class="_w-15 _h-15 _mar-right-10"
		          src="@assets/images/icon/test-weixuanzhong.png"
		          alt=""
		        />
		        <div>如不确认出生时辰，直接勾选提交</div>
		      </div>
		    
		    </div>
		  </div>
          <div class="input-box _flex-row-bet-mid">
            <div>联系人姓名</div>
            <input
              class="_flex-1 _pad-left-15 _text-right"
              type="text"
			  @focus="check"
              placeholder="请输入姓名..."
              v-model="username"
              placeholder-style="color: rgba(177, 138, 103, 0.6);"
            />
          </div>
          <div class="_flex-row-bet-mid _mar-top-20 padding-x">
            <img
              class="report-box"
              @click="history"
              src="https://sz.daolongsz.com/static/wodejilu.png"
              alt=""
            />
            <!-- 9.9元四柱解读 -->
            <img
              class="read-box"
              v-if="free"
              @click="startTest"
              src="https://sz.daolongsz.com/static/ceshijieguo.png"
              alt=""
            />

            <!-- 免费阅读 -->
           <img
             class="read-box"
             v-else
              @click="createOrder"
             src="https://sz.daolongsz.com/static/ceshijieguo.png"
             alt=""
           />
           <!-- <div  @click="createOrder" class="read-box" style="background: #7C4D4E;color: #fff;font-size: 16px; text-align: center; line-height: 0.82rem">
                获取报告
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="mask-box acea-row row-column row-center row-middle" v-if="notice_popup">
      <div class="dialog acea-row row-column row-middle">
        <div class="title">新版测试系统已经正式上线，请移步灵应宗文化公众号进行测试。</div>
        <img class="code" src="@assets/images/icon/qr-code.jpg" alt="">
        <div class="btn" @click="saveCode">保存二维码</div>
      </div>
      <!-- <div class="iconfont icon-guanbi2" @click="closeNoticePopup"></div> -->
    </div>

    <div class="_flex-row-bet-end _pos-rel _w-max">
      <img
        class="bottom-pic"
        src="@assets/images/icon/test-icon-3.png"
        alt=""
      />
      <img
        class="bottom-mid-pic"
        src="@assets/images/icon/test-logo.png"
        alt=""
      />
      <img
        class="bottom-pics"
        src="@assets/images/icon/test-icon-2.png"
        alt=""
      />
    </div>
    <div style="height:1.2rem;"></div>

    <div class="picler-box" v-if="yearPicker">
      <van-picker
        show-toolbar
        :columns="years"
        @confirm="yearConfirm"
        @cancel="yearCancel"
        @change="yearChange"
      />
    </div>
    <div class="picler-box" v-if="monthPicker">
      <van-picker
        show-toolbar
        :columns="months"
        @confirm="monthConfirm"
        @cancel="monthCancel"
        @change="monthChange"
      />
    </div>
    <div class="picler-box" v-if="dayPicker">
      <van-picker
        show-toolbar
        :columns="days"
        @confirm="dayConfirm"
        @cancel="dayCancel"
        @change="dayChange"
      />
    </div>
    <div class="picler-box" v-if="timePicker">
      <van-picker
        show-toolbar
        :columns="timeColumns"
        @confirm="timeConfirm"
        @cancel="timeCancel"
        @change="timeChange"
      />
    </div>
	  <div style="height: 1.2rem;"></div>
    <div id="overlay" class="overlay" v-if="isWeixinPc">
      <div class="overlay-content">
        <p>请使用手机微信访问</p>
      </div>
    </div>

    
  </div>


</template>

<script>
import { getUserInfo } from "@api/user";
import { wechatEvevt } from "@libs/wechat";
import { openShareAll } from "@libs/wechat";
import { getShare} from "@api/public";
import { isWeixin } from "@utils/index";
import {postSizhuOrderCreate} from "@api/order";
import { getUser } from "@api/user";
import { pay } from "@libs/wechat";
import { Toast } from "vant";
import { mapGetters } from "vuex";
export default {
  data: function () {
    return {
		isWeixin: isWeixin(),
		statusBarHeight: "",
		sex: null,
		lunisolar: null,
		startYear: 1930,
		endYear: new Date().getFullYear(),
		yearPicker: false,
		monthPicker: false,
		dayPicker: false,
		timePicker: false,
		timeColumns: [
			"01:00~03:00",
			"03:00~05:00",
			"05:00~07:00",
			"07:00~09:00",
			"09:00~11:00",
			"11:00~13:00",
			"13:00~15:00",
			"15:00~17:00",
			"17:00~19:00",
			"19:00~21:00",
			"21:00~23:00",
			"23:00~01:00",
		],
		year: "",
		month: "",
		day: "",
		free: false,
		years:[],
		months:[],
		days:[],
		has_hour:false,
		time:'',
		isWeixinPc: false,
		timePicker: "",
		free: false,
		years:[],
		months:[],
		days:[],
		has_hour:false,
		notice_popup: true,
    };
  },
	computed: mapGetters(["isLogin"]),
	created() {
    if (!isWeixin()) {
      // this.isWeixinPc = true;
    }
    if (this.isPCWeChatBrowser()) {
      this.isWeixinPc = true;
      console.log('当前浏览器是PC版微信浏览器');
      return;
    } else {
      // document.getElementById('overlay').style.display = 'block';
      console.log('当前浏览器不是PC版微信浏览器');
    }
    var domainName = window.location.hostname;
    var href = window.location.href;
    console.log(href);
    console.log(domainName);
    if(domainName == 'sizhu.uxphp.net'){
      let newUrl = href.replace(domainName, "sz.daolongsz.com");
      window.location.href = newUrl;
    }
		const statusBarHeight =  window.innerHeight - document.documentElement.clientHeight;
		this.statusBarHeight = statusBarHeight;
		this.User();
		this.years = this.yearColumns();
		this.months = this.monthColumns();
		this.days = this.dayColumns();
	},
	mounted: function () {
		this.setOpenShare();
	},

	methods: {
		isPCWeChatBrowser(){
		  var userAgent = navigator.userAgent.toLowerCase();
		  var isWeChat = userAgent.indexOf('micromessenger') !== -1;
		  var isWindows = userAgent.indexOf('windows') !== -1;
		  var isMacintosh = userAgent.indexOf('macintosh') !== -1;

		  // 判断是否为PC端微信浏览器
		  return isWeChat && (isWindows || isMacintosh);
		},


		setOpenShare: function() {
			let that = this;
		  var href = location.href;
		  if (isWeixin()) {
			getShare().then(res1 => {
				var data = res1.data.data;
				console.log(data);
				if (that.isLogin) {
				  getUserInfo().then(res => {
					  console.log(res.data);
				    href =
				      href.indexOf("?") === -1
				        ? href + "?spread=" + res.data.uid
				        : href + "&spread=" + res.data.uid;
				    var configAppMessage = {
				      desc: data.synopsis,
				      title: data.title,
				      link: href,
				      imgUrl: data.img
				    };
					console.log(configAppMessage);
					console.log(href);
				    wechatEvevt(
				      [
				        "updateAppMessageShareData",
				        "updateTimelineShareData",
				        "onMenuShareAppMessage",
				        "onMenuShareTimeline"
				      ],
				      configAppMessage
				    )
				      .then(res => {
				        console.log(res);
				      })
				      .catch(res => {
				        if (res.is_ready) {
				          res.wx.updateAppMessageShareData(configAppMessage);
				          res.wx.onMenuShareAppMessage(configAppMessage);
				          res.wx.updateTimelineShareData(configAppMessage);
				          res.wx.onMenuShareTimeline(configAppMessage);
				        }
				      });
				  });
				} else {
				  var configAppMessage = {
				    desc: data.synopsis,
				    title: data.title,
				    link: href,
				    imgUrl: data.img
				  };
				  console.log(configAppMessage);
				  console.log(href);
				  wechatEvevt(
				    [
				      "updateAppMessageShareData",
				      "updateTimelineShareData",
				      "onMenuShareAppMessage",
				      "onMenuShareTimeline"
				    ],
				    configAppMessage
				  )
				    .then(res => {
				      console.log(res);
				    })
				    .catch(res => {
				      if (res.is_ready) {
				        res.wx.updateAppMessageShareData(configAppMessage);
				        res.wx.onMenuShareAppMessage(configAppMessage);
				        res.wx.updateTimelineShareData(configAppMessage);
				        res.wx.onMenuShareTimeline(configAppMessage);
				      }
				    });
				}
			})
		  }
		},
		yearColumns() {
		  const years = [];
		  for (let year = this.endYear; year >= this.startYear; year--) {
			years.push(year);
		  }
		  return years;
		},
		monthColumns() {
		  const months = [];
		  for (let month = 1; month <= 12; month++) {
			months.push(month);
		  }
		  return months;
		},
		dayColumns() {
		  const days = [];
		  for (let day = 1; day <= 31; day++) {
			days.push(day);
		  }
		  return days;
		},
		User: function() {
		  let that = this;
		  getUser().then(res => {
		    that.userInfo = res.data;
        if(res.data.phone==null || res.data.phone=='' ){
          that.$router.push('/sizhu/register');
        }
		  });
		},
		createOrder() {
			let that = this;
			if (that.sex==null) return that.$dialog.toast({ mes: "请选择性别" });
		    if (that.lunisolar== null ) return that.$dialog.toast({ mes: "请选择阴历或是阳历" });
		    if (!that.year) return that.$dialog.toast({ mes: "请选择出生年份" });
		    if (!that.month) return that.$dialog.toast({ mes: "请选择出生月份" });
		    if (!that.day) return that.$dialog.toast({ mes: "请选择出生日期" });
			if(!that.has_hour){
				if (!that.time) return that.$dialog.toast({ mes: "请选择出生时辰" });
			}
		
		    if (!that.username)  return that.$dialog.toast({ mes: "请输入姓名" });
			
			let data = {
			    free: that.free ? 1 : 0,
			    gender: that.sex == 1 ? '男' : '女',
			    calendar: that.lunisolar == 1 ? 0 : 1,
			    year:that.year,
			    month: that.month,
			    day: that.day,
			    hour: that.time?that.time:'-1',
			    sizhu: 0,
			    payType: 'weixin',
			    username: that.username,
				from:'wechat',
			};
			that.$dialog.loading.open("生成订单中");
			postSizhuOrderCreate(data).then(res=>{
				const data = res.data;
				that.$dialog.loading.close();
				 let url = '';
				switch (data.status) {
				  case "ORDER_EXIST":
				  case "EXTEND_ORDER":
				  case "PAY_DEFICIENCY":
				  case "PAY_ERROR":
				    that.$dialog.toast({ mes: res.msg });
				    that.$router.replace({
				      path: url + "/0?msg=" + res.msg
				    });
				    break;
				  case "SUCCESS":
				    that.$dialog.success(res.msg);
            that.$router.push("/sizhu/result/" + data.result.order.id);
				    break;
				  case "WECHAT_H5_PAY":
				    this.$router.replace({
				      path: url + "/2"
				    });
				    setTimeout(() => {
				      location.href = data.result.jsConfig.mweb_url;
				    }, 100);
				    break;
				  case "WECHAT_PAY":
					console.log(data.result.jsConfig);
				    pay(data.result.jsConfig).finally((res) => {
						console.log(res);
						if(data.result.orderCount==0){
							that.$router.push('/sizhu/qrcode');
						}else{
							that.$router.push("/sizhu/result/" + data.result.order.id);
						}
						if (res.err_msg == "get_brand_wcpay_request:ok") {
							
						    
						}else if(res.err_msg == "get_brand_wcpay_request:cancel"){
							return that.$dialog.toast({ mes: "取消支付" })
						}else if(res.err_msg == "get_brand_wcpay_request:fail"){
							return that.$dialog.toast({ mes: "支付失败" })
						}
						
				    });
				}
			}).catch(err=>{
				that.$dialog.loading.close();
				return that.$dialog.toast({ mes: err.msg })
			})	
		},
		onBack() {
		  this.$router.go(-1);
		},
		selectSex(e) {
		  this.sex = e;
		},
		selectHour(e) {
			if(this.time !=''){
				return this.$dialog.toast({ mes: '已选择时辰,不能勾选' })
			}
		  this.has_hour = !this.has_hour;
		},
		// selectHour(e) {
		//   this.has_hour = !this.has_hour;
		// },
		selectLunisolar(e) {
		  this.lunisolar = e;
		},
		onPickerChange(value) {
		  this.selectedYear = value[0];
		},
		yearConfirm(value, index) {
		  console.log(`当前值：${value}, 当前索引：${index}`);
		  this.year = value;
		  this.yearPicker = false;
		},
		yearChange(picker, value, index) {
		  console.log(`当前值：${value}, 当前索引：${index}`);
		},
		yearCancel() {
		  this.yearPicker = false;
		  console.log("取消");
		},
		monthConfirm(value, index) {
		  console.log(`当前值：${value}, 当前索引：${index}`);
		  this.month = value;
		  this.monthPicker = false;
		},
		monthChange(picker, value, index) {
		  console.log(`当前值：${value}, 当前索引：${index}`);
		},
		monthCancel() {
		  this.monthPicker = false;
		  console.log("取消");
		},
		dayConfirm(value, index) {
		  console.log(`当前值：${value}, 当前索引：${index}`);
		  this.day = value;
		  this.dayPicker = false;
		},
		dayChange(picker, value, index) {
		  console.log(`当前值：${value}, 当前索引：${index}`);
		},
		dayCancel() {
		  this.dayPicker = false;
		  console.log("取消");
		},
		timeConfirm(value, index) {
		  console.log(`当前值：${value}, 当前索引：${index}`);
		  console.log(value);
		  this.time = value;
		  this.timePicker = false;
		},
		timeChange(picker, value, index) {
		  console.log(`当前值：${value}, 当前索引：${index}`);
		},
		timeCancel() {
		  this.timePicker = false;
		  console.log("取消");
		},

		check() {
			if(!this.has_hour){
				if (!this.time) {
					Toast("请选择出生时辰");
				}
			}
		},
		// 跳转测试记录
		history() {
			this.$router.push('/sizhu/history');
		},
		// 开始测算
		startTest() {
			this.$router.push('/sizhu/result');
		},

    saveCode(){
      const link = document.createElement('a')
      link.href = '@assets/images/icon/qr-code.jpg'
      link.download = 'lingyingzong.jpg' // 设置下载的文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    closeNoticePopup(){
      this.notice_popup = false;
    },
  },
};
</script>
<style>
	.van-picker-column__item--selected{
		color: #f00;
	}
</style>
<style lang="scss" scoped>
/* 遮罩层样式 */
.overlay {
  position: fixed; /* 固定定位 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  z-index: 1000; /* 确保遮罩层在最上层 */
}

/* 内容容器样式 */
.overlay-content {
  position: absolute; /* 绝对定位 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 居中显示 */
  background-color: white; /* 白色背景 */
  padding: 20px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.content {
  min-height: 100vh;
  background: #fff9ef;
}
.head-box {
  width: 100%;
  overflow: hidden;
  position: relative;
  position: fixed;
  top: 0;
  z-index: 999;
  .head-bg {
    position: absolute;
    top: 0;
    width: 100%;
  }
  .head {
    position: relative;
    width: 100%;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    font-size: 0.32rem;
    color: #fff;
    .iconfont {
      position: absolute;
      top: 50%;
      left: 0.3rem;
      transform: translateY(-50%);
      font-size: 0.4rem;
    }
  }
}
.tips-box {
  width: 100%;
  padding: 0 0.28rem;
  margin-top: -1.58rem;
  position: relative;
}
.write-tips {
  height: 1.54rem;
}
.form-bg {
  width: 100%;
  .form-box {
    width: calc(100% - 0.56rem);
    margin: 0.38rem auto 0;
    position: relative;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(https://sz.daolongsz.com//static/test-bg.png);
    .sex-box {
      width: 100%;
      padding: 0.6rem 0.22rem 0.4rem 0.32rem;
      border-bottom: 0.02rem solid rgba(105, 80, 60, 0.1);
      font-size: 0.28rem;
      color: #69503c;
    }
    .birthday-box {
      width: 100%;
      padding: 0.4rem 0 0.8rem 0;
      font-size: 0.28rem;
      color: #69503c;
      .padding-x {
        padding-left: 0.32rem;
        padding-right: 0.32rem;
      }
      .day-box {
        min-width: 1.36rem;
        padding: 0.2rem;
        border-radius: 0.05rem;
        background-color: rgba(255, 251, 245, 1);
      }
      .year-box {
        min-width: 1.56rem !important;
      }
      .time-box {
        min-width: 2.46rem !important;
      }
      .input-box {
        width: 100%;
        padding: 0.34rem 0.32rem;
        border-bottom: 1px solid rgba(105, 80, 60, 0.1);
        color: #69503c;
        font-size: 0.28rem;
      }
      .report-box {
        width: 1.66rem;
        height: 0.82rem;
      }
      .read-box {
        width: 4.22rem;
        height: 0.82rem;
      }
    }
  }
}
.bottom-pic {
  width: 2.48rem;
  height: 2.26rem;
}

.bottom-mid-pic {
  width: 2.38rem;
  height: 0.6rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.bottom-pics {
  width: 2.8rem;
  height: 1.82rem;
}
.picler-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: 0.3);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.mask-box{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.dialog{
  padding: 15px;
  width: 300px;
  background-color: #fff;
  border-radius: 10px;
}

.dialog .title{
  text-align: center;
  padding: 0 25px;
  font-size: 15px;
  font-weight: bold;
  color: #000;
}

.dialog .code{
  width: 180px;
  height: 180px;
  margin-top: 25px;
}

.dialog .tips{
  color: #a87f5c;
  margin-top: 15px;
}

.dialog .btn{
  width: 100%;
  height: 45px;
  text-align: center;
  line-height: 45px;
  background-color: #a87f5c;
  color: #fff;
  font-size: 14px;
  margin-top: 15px;
  border-radius: 100px;
}

.mask-box .icon-guanbi2{
  text-align: center;
  font-size: 25px;
  margin-top: 15px;
  color: #fff;
}

</style>